import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INITIAL_STATE = {
  allFilter: false,
  activitiesFilter: {}
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "UPDATE_FILTER":
      if (action.payload.allData) {
        return _objectSpread(_objectSpread({}, state), {}, {
          activitiesFilter: action.payload.obj,
          allFilter: true
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        activitiesFilter: _objectSpread(_objectSpread({}, state.activitiesFilter), action.payload.obj),
        allFilter: false
      });
    case "CLEAR_FILTER":
      return _objectSpread(_objectSpread({}, state), {}, {
        activitiesFilter: {},
        allFilter: false
      });
    default:
      return state;
  }
}